
import m, {Vnode} from "mithril";
import CustomForm from "../CustomForm";
import {LabelItem} from "../../model/items/labelItem";
import MaxDiffState, {TMaxDiffRow} from "./MaxDiffState";
import ICustomFormSettings from "../ICustomFormSettings";
import Cell from "../../model/form/cell";
import {ImageItem} from "../../model/items/imageItem";
import Image from "../shared/components/Image/Image";
import {TextboxItem} from "../../model/items/textbox";

export default abstract class MaxDiff extends CustomForm {

    protected readonly winLabel: LabelItem;
    protected readonly loseLabel: LabelItem;

    public readonly state: MaxDiffState;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        const layout = this.settings.form.grid.layout;

        this.winLabel = <LabelItem>layout[0][0].cellItems[0];
        this.loseLabel = <LabelItem>layout[0][1].cellItems[0];

        let rows = [];
        for (let i=1; i<layout.length; i++) {
            rows.push(this.parseRow(layout[i]));
        }
        rows = rows.filter(row => (row.label || row.image) && row.ratings.length);

        const options = {
            finalRound: false,
            itemsPerRound: 4,
        };

        try {
            const maxDiffOptions = JSON.parse(settings.form.aux1 || '{}');
            options.finalRound = Boolean(maxDiffOptions?.final);
            options.itemsPerRound = maxDiffOptions?.items ?? 4;
        } catch (err) {
            console.log('customForm-MaxDiff-default: JSON in aux1 is invalid.')
        }

        this.state = new MaxDiffState(rows, options);
    }


    public checkRequirements(): boolean {
        if (!this.state.rows.length) {
            console.log(`customForm-MaxDiff: Cannot load Textboxes.`);
            return false;
        }

        for (const row of this.state.rows) {
            if (!row.ratings.length) {
                console.log(`customForm-MaxDiff: Expected Textbox for rating missing (at row with label ${row.label?.label})`);
                return false;
            }
        }

        return true;
    }

    public rewriteFormControls() {
        return true;
    }


    private parseRow(row: Cell[]): TMaxDiffRow {
        const cellItems = row.map(cell => cell.cellItems[0]);
        const label = <LabelItem>cellItems.filter(ci => ci instanceof LabelItem)[0];
        const image = <ImageItem>cellItems.filter(ci => ci instanceof ImageItem)[0];
        const ratings = <TextboxItem[]>cellItems.filter(ci => ci instanceof TextboxItem);

        return {
            label: label,
            image: image ? new Image(image) : undefined,
            ratings: ratings,
        };
    }


    protected onClickPrev(): void {
        if (this.state.round === 0) {
            this.settings.prevForm();
        } else {
            this.state.prevRound();
        }
    }

    protected onClickNext(): void {
        if (this.state.isLastRound()) {
            this.settings.nextForm();
        } else {
            this.state.nextRound();
        }
    }


    protected viewProgress(): Vnode {
        return m('.progress', {}, (this.state.round+1)+'/'+this.state.getRoundCount());
    }

    protected viewControls(): Vnode {
        const visibleLangButton = this.settings.app.langSwitcherEnabled();

        return m(".controls", {},
            m(".control-group", {}, [
                this.controls.viewPreviousButton(undefined, () => this.onClickPrev()),
                visibleLangButton ? this.controls.viewLanguageButton() : null,
                this.controls.viewNextButton(undefined, () => this.onClickNext(), () => this.state.canNext()),
            ])
        );

    }
}